(function(window, document) {"use strict";

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/;";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') {
        c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
        return c.substring(name.length,c.length);
    }
  }
  return "";
}

function unescapeHtml(text)  {
  return text.replace(/&amp;/g,"&")
             .replace(/&lt;/g,"<")
             .replace(/&gt;/g,">")
             .replace(/&quot;/g,'"')
             .replace(/&#39;/g,"'")
}

function actOnVariantChange(cb){
    //Just periodically check variant url param and callback if variant changed
    setInterval(function(){
      var currentId  = getUrlParam('variant');
      var previousId = window.booster.currentVariantId;
      if (currentId && currentId != previousId){cb(currentId)}
    }, 750);
}

function lastUrlSegment(){
  var lastPart = location.href.substr(location.href.lastIndexOf('/') + 1)
  //Remove url params if this is the case.
  return lastPart.substr(0,lastPart.indexOf('?') > -1 ? lastPart.indexOf('?') : lastPart.length)
}


  //will shuffle elements
  function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
  }



function isMobileBrowser()  {
  var isMobile = false; //initiate as false
  try {
    // Device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      isMobile = true;
    }
   }
   catch(e) {}
   return  isMobile
}

if (document.location.search.indexOf("clear_cookies=1") != -1){
  setCookie('ba-skip-ids', '');
  setCookie('cart', '');
}


function reqJquery(onload) {
  if(typeof jQuery === 'undefined' || (parseInt(jQuery.fn.jquery) === 1 && parseFloat(jQuery.fn.jquery.replace(/^1\./,'')) < 10)){
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'ajax.googleapis.com/ajax/libs/jquery/1.12.0/jquery.min.js';;
    script.type = 'text/javascript';
    script.onload = script.onreadystatechange = function() {
      if (script.readyState) {
        if (script.readyState === 'complete' || script.readyState === 'loaded') {
          script.onreadystatechange = null;
          onload(jQuery.noConflict(true));
        }
      }
      else {
        onload(jQuery.noConflict(true));
      }
    };
    head.appendChild(script);
  }else {
    onload(jQuery);
  }
}

//Will generate 'style' block with global css rule
//Param ex: 'h1 { background: red; }'
function addGlobalStyle(css)  {
  try {
    var head  = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.innerHTML = css
    style.type      = 'text/css';
    head.appendChild(style);
  }
  catch(e) {}
}

function addCheckoutEvent(callback)  {
  try {
    var els = document.querySelectorAll(baCheckoutSelector);
    if (typeof els == "object" && els) {
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (typeof el.addEventListener != "function") continue;
        el.addEventListener("click", function(e) {
          try {
            callback(e);
          }
          catch(err) {
            window.location = '/checkout';
          }
        }, false);
      }
    }
  }
  catch(ex) {}
}

reqJquery(function($){
  var settings = {app_root_url: '/apps/discounted_pricing',
                  app_name:     'bundle',
                  shop_domain:  ''};

  if (document.location.href.indexOf("checkouts") < 0){
    try {
      if(getCookie('ba-pr-id') !== undefined && getCookie('ba-pr-id') != ''){
        var prId = getCookie('ba-pr-id');
        $.ajax({
          cache: false,
          type: "POST",
          url: settings.app_root_url,
          data: JSON.stringify({action_type: "remove_discount", pr_id: prId}),
          dataType: 'json',
          contentType: "application/json; charset=utf-8",
          success: function(data) {
            console.log('done');
          }
        });
      }
    }
    catch(e) { console.log(e) }
    finally {setCookie('ba-pr-id', '', 365);}
  }

  function registerEvent(event_name,params){
    //Temporarily disabled
    return false;
    try
    {
      
      params["shop_id"] = '7638548577';
      var event_key = "ba_" + event_name + "_" + params["app_type"] + "_" + params["shop_id"] + "_" + params["offer_id"];
      if (getCookie(event_key) != 1)  {
        //Add 'event' cookie that will expire in 1 day
        setCookie(event_key, 1, 1);
        $.ajax({
          type: "POST",
          url: settings.app_root_url + "/measure",
          data: JSON.stringify({event_name: event_name, data: params}),
          dataType: 'json',
          contentType: "application/json; charset=utf-8",
          success: function(data) {}
        })
      }
    }
    catch(ex) {}
  }

  if (document.location.search.indexOf("prefill=1") != -1){
    if (localStorage.getItem('bd_first_test_offer_token')){ localStorage.setItem('ba_keep_tk',1) }
    var reloadUrl = window.location.origin + "/cart/add?id[]=" + window.location.href.split('prefill=1&variant_id=')[1]
    window.location =reloadUrl;
  }

  function postNotFoundError(handle) {
     $.ajax({
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        type: "POST",
        url: settings.app_root_url,
        data: JSON.stringify({error: 404, handle: handle}),
        success: function(res) {
          console.log('error posted')
        },
        error: function(){
        }
      })
  }

  var dpQuery=$,dpModals=[],getCurrent=function(){return dpModals.length?dpModals[dpModals.length-1]:null},selectCurrent=function(){var a,b=!1;for(a=dpModals.length-1;a>=0;a--)dpModals[a].$blocker&&(dpModals[a].$blocker.toggleClass("current",!b).toggleClass("behind",b),b=!0)};dpQuery.dpModal=function(a,b){var c,d;if(this.$body=dpQuery("body"),this.options=dpQuery.extend({},dpQuery.dpModal.defaults,b),this.options.doFade=!isNaN(parseInt(this.options.fadeDuration,10)),this.$blocker=null,this.options.closeExisting)for(;dpQuery.dpModal.isActive();)dpQuery.dpModal.close();if(dpModals.push(this),a.is("a"))if(d=a.attr("href"),/^#/.test(d)){if(this.$elm=dpQuery(d),1!==this.$elm.length)return null;this.$body.append(this.$elm),this.open()}else this.$elm=dpQuery("<div>"),this.$body.append(this.$elm),c=function(a,b){b.elm.remove()},this.showSpinner(),a.trigger(dpQuery.dpModal.AJAX_SEND),dpQuery.get(d).done(function(b){if(dpQuery.dpModal.isActive()){a.trigger(dpQuery.dpModal.AJAX_SUCCESS);var d=getCurrent();d.$elm.empty().append(b).on(dpQuery.dpModal.CLOSE,c),d.hideSpinner(),d.open(),a.trigger(dpQuery.dpModal.AJAX_COMPLETE)}}).fail(function(){a.trigger(dpQuery.dpModal.AJAX_FAIL);var b=getCurrent();b.hideSpinner(),dpModals.pop(),a.trigger(dpQuery.dpModal.AJAX_COMPLETE)});else this.$elm=a,this.$body.append(this.$elm),this.open()},dpQuery.dpModal.prototype={constructor:dpQuery.dpModal,open:function(){var a=this;this.block(),this.options.doFade?setTimeout(function(){a.show()},this.options.fadeDuration*this.options.fadeDelay):this.show(),dpQuery(document).off("keydown.dpModal").on("keydown.dpModal",function(a){var b=getCurrent();27==a.which&&b.options.escapeClose&&b.close()}),this.options.clickClose&&this.$blocker.click(function(a){a.target==this&&dpQuery.dpModal.close()})},close:function(){dpModals.pop(),this.unblock(),this.hide(),dpQuery.dpModal.isActive()||dpQuery(document).off("keydown.dpModal")},block:function(){this.$elm.trigger(dpQuery.dpModal.BEFORE_BLOCK,[this._ctx()]),this.$body.css("overflow","hidden"),this.$blocker=dpQuery('<div class="jquery-dpModal blocker current"></div>').appendTo(this.$body),selectCurrent(),this.options.doFade&&this.$blocker.css("opacity",0).animate({opacity:1},this.options.fadeDuration),this.$elm.trigger(dpQuery.dpModal.BLOCK,[this._ctx()])},unblock:function(a){!a&&this.options.doFade?this.$blocker.fadeOut(this.options.fadeDuration,this.unblock.bind(this,!0)):(this.$blocker.children().appendTo(this.$body),this.$blocker.remove(),this.$blocker=null,selectCurrent(),dpQuery.dpModal.isActive()||this.$body.css("overflow",""))},show:function(){this.$elm.trigger(dpQuery.dpModal.BEFORE_OPEN,[this._ctx()]),this.options.showClose&&(this.closeButton=dpQuery('<a href="#close-dpModal" rel="dpModal:close" class="close-dpModal '+this.options.closeClass+'">'+this.options.closeText+"</a>"),this.$elm.append(this.closeButton)),this.$elm.addClass(this.options.dpModalClass).appendTo(this.$blocker),this.options.doFade?this.$elm.css("opacity",0).show().animate({opacity:1},this.options.fadeDuration):this.$elm.show(),this.$elm.trigger(dpQuery.dpModal.OPEN,[this._ctx()])},hide:function(){this.$elm.trigger(dpQuery.dpModal.BEFORE_CLOSE,[this._ctx()]),this.closeButton&&this.closeButton.remove();var a=this;this.options.doFade?this.$elm.fadeOut(this.options.fadeDuration,function(){a.$elm.trigger(dpQuery.dpModal.AFTER_CLOSE,[a._ctx()])}):this.$elm.hide(0,function(){a.$elm.trigger(dpQuery.dpModal.AFTER_CLOSE,[a._ctx()])}),this.$elm.trigger(dpQuery.dpModal.CLOSE,[this._ctx()])},showSpinner:function(){this.options.showSpinner&&(this.spinner=this.spinner||dpQuery('<div class="'+this.options.dpModalClass+'-spinner"></div>').append(this.options.spinnerHtml),this.$body.append(this.spinner),this.spinner.show())},hideSpinner:function(){this.spinner&&this.spinner.remove()},_ctx:function(){return{elm:this.$elm,$blocker:this.$blocker,options:this.options}}},dpQuery.dpModal.close=function(a){if(dpQuery.dpModal.isActive()){a&&a.preventDefault();var b=getCurrent();return b.close(),b.$elm}},dpQuery.dpModal.isActive=function(){return dpModals.length>0},dpQuery.dpModal.defaults={closeExisting:!0,escapeClose:0,clickClose:0,closeText:"Close",closeClass:"",dpModalClass:"dp-popup-dpModal",spinnerHtml:null,showSpinner:!0,showClose:!0,fadeDuration:null,fadeDelay:1},dpQuery.dpModal.BEFORE_BLOCK="dpModal:before-block",dpQuery.dpModal.BLOCK="dpModal:block",dpQuery.dpModal.BEFORE_OPEN="dpModal:before-open",dpQuery.dpModal.OPEN="dpModal:open",dpQuery.dpModal.BEFORE_CLOSE="dpModal:before-close",dpQuery.dpModal.CLOSE="dpModal:close",dpQuery.dpModal.AFTER_CLOSE="dpModal:after-close",dpQuery.dpModal.AJAX_SEND="dpModal:ajax:send",dpQuery.dpModal.AJAX_SUCCESS="dpModal:ajax:success",dpQuery.dpModal.AJAX_FAIL="dpModal:ajax:fail",dpQuery.dpModal.AJAX_COMPLETE="dpModal:ajax:complete",dpQuery.fn.dpModal=function(a){return 1===this.length&&new dpQuery.dpModal(this,a),this},dpQuery(document).on("click.dpModal",'a[rel="dpModal:close"]',dpQuery.dpModal.close),dpQuery(document).on("click.dpModal",'a[rel="dpModal:open"]',function(a){a.preventDefault(),dpQuery(this).dpModal()});



  function reloadCurrency() {
    if (typeof Currency == "object" && typeof Currency.moneyFormats == "object" && typeof mlvedaload == "function") {
      mlvedaload()
    }

    try {
      if (typeof DoublyGlobalCurrency == "object" && typeof DoublyGlobalCurrency.convertAll == "function")  {
        DoublyGlobalCurrency.convertAll(jQueryGrizzly('[name=doubly-currencies]').val());
      }
    } catch(ex) { console.log(ex) }
  }

  $("span.Bold-theme-hook-DO-NOT-DELETE.bold_cart_total").remove();
  $("span#bk-cart-subtotal-price").attr("id", "");

  var boosterCookieCode = getCookie('booster_discount_' + window.booster.cart.token);
  if(boosterCookieCode){
    window.booster.discount_code = boosterCookieCode;
  }

  function showPreviewJs(app, result){
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    
    window.preview_result = result;
    script.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'boosterapps.com/apps/upsell-bundles/preview_offer_' + app + '.js';
    script.type = 'text/javascript';
    head.appendChild(script);
  }

  function checkAndShowPreviewJs(app, result){
    if (app == 'buyx'){
      if(localStorage.getItem('bd_first_test_offer_return_url').length > 0){
        showPreviewJs('buyx', result);
      }
    } else if (app == 'dp'){
      if(document.location.search.indexOf("preview_offer=1") > -1){
        showPreviewJs('dp', result);
      }
    } else if (app == 'bundle'){
      if(document.location.search.indexOf("preview_offer=1") > -1){
        showPreviewJs('bundle', result);
      }
    }
  }

  function baDisplayCents(cents) {
	if (typeof cents == "undefined" || cents == null){return ""}
	if (typeof cents == "string" && cents.length == 0){return ""}

    var format = window.booster.money_format;
    var moneyRegex = /\{\{\s*(\w+)\s*\}\}/;
    if (typeof cents == "string") {
      cents = cents.replace(".", "")
    }

    function defOpt(opt,def){return typeof opt == "undefined" ? def : opt}

    function displayDelims(n,p,t,d){
        p = defOpt(p, 2);
        t = defOpt(t, ",");
        d = defOpt(d, ".");
        if (isNaN(n) || n == null){
          return 0
        }
        n = (n / 100).toFixed(p);
        var parts = n.split("."),dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t),cents = parts[1] ? d + parts[1] : "";
        return dollars + cents
    }

    var val = "";
    switch (format.match(moneyRegex)[1]) {
      case "amount":
        val = displayDelims(cents, 2);
        break;
      case "amount_no_decimals":
        val = displayDelims(cents, 0);
        break;
          case "amount_no_decimals_with_comma_separator":
        val = displayDelims(cents, 0, ".", ",");
        break
      case "amount_with_comma_separator":
        val = displayDelims(cents, 2, ".", ",");
        break;
    }
    return format.replace(moneyRegex, val)
  }

  function baDiscountedPrice(price, discountApplies, discountMethod, disValue,app){
    if (discountApplies){
      if (discountMethod == 'percent'){
        var multipler = 1 - (parseFloat(disValue) / 100.00);
        var baPrice = price * multipler;
      }
      else if (discountMethod == 'fixed'){
        var baPrice = (disValue * 100);
      }
      else if (discountMethod == 'off'){
        var baPrice = price - (disValue * 100);
      }
      if (baPrice < 0) baPrice = 0;

      var disPrice = baDisplayCents(baPrice);
      var ogPrice  = baDisplayCents(price);
      var str = disPrice + " <s>" + ogPrice + "</s>";
    } else {
      var str = baDisplayCents(price);
    }
  

    return str
  }

  function baSearchProducts(product_ids, callback) {
    if (!product_ids || !product_ids.length) return false;
    //Build query
    var query = product_ids.map(function(id){ return 'id:' + id }).join(' OR ');
    $.ajax({
        url: '/search',
        type: "POST",
        dataType: "json",

        data: { view: 'ba-rec',
                type: 'product',
                q:     query },

        success: callback,
        error: function(e) { console.log(e) }
    });
  }

  function getVariantsInStock(productHandles,collectionHandles,funnel,callback) {
    var origin = document.location.protocol + "//" + document.location.hostname;
    var view_suffix = funnel ? 'booster_funnel_script' : 'booster_stock_script';
    $.ajax({
      url: origin + "/?view=" + view_suffix + "&cache=false&ba_check_stock=" + encodeURIComponent(productHandles.join(',')) + "&ba_collections=" + encodeURIComponent(collectionHandles.join(',')),
      cache: false,
      type: "GET",
      dataType: "html",
      success: function(product_page) {
        try {
          var script = product_page.substring(product_page.indexOf('//booster-check-products-stock'),
            product_page.indexOf('booster-check-products-stock-end'));
          eval(script)
          callback(window.booster.productsInStock);
        }
        catch(err) {
          postNotFoundError(productHandles)
        }
      },
      error: function(data) {
        postNotFoundError(productHandles);
      }
    })
  }

 function allBundleItemsInStock(productHandles,cb){
   var allInStock = true
   getVariantsInStock(productHandles, [],false, function(productsStock) {
     // Checks each product for stock availablity and pass boolean to array
       for (var id in productsStock)  {
         if (productsStock[id].available == "false")  {
           allInStock = false
         }
       }
     cb(allInStock)
   });
 }

 function showBoosterBundle(ba_data){
	var arr               = [];
	var products          = [];
	var enhancedProducts  = [];
	var fixedDiscountSet  = false;

	var prodQty = function(product_id) {
    var prod = ba_data.items.filter(function(item){ return item.id == product_id})[0]
    return (prod && prod.qty) ? prod.qty : 1;
  };

 var enhanceProduct = function(data,p) {
      var prod = data.product;
      prod.variantsStyle  = "";
      prod.variantsSelect = "";
      prod.quantity = p.qty || 1;
      for (var i = 0; i < prod.variants.length; i++) {
        //Assign default variant for the page product.
        if (!window.booster.currentVariantId && prod.variants[i] && prod.variants[i].position == 1 && lastUrlSegment() == p.handle){
          window.booster.currentVariantId = prod.variants[i].id;
        }

        if (typeof prod.variants[i].price == "string") {
          prod.variants[i].price = parseFloat(prod.variants[i].price) * 100
        }
        if (typeof prod.variants[i].compare_at_price == "string") {
          prod.variants[i].compare_at_price = parseFloat(prod.variants[i].compare_at_price) * 100
        }
        prod.variants[i].og_compare_at_price = prod.variants[i].compare_at_price;
        var numericPrice          = prod.variants[i].price;
        var qtyPrice              = numericPrice * prodQty(prod.id)
        prod.variants[i].og_price = qtyPrice;
        if (prod.variants[i].compare_at_price && prod.variants[i].compare_at_price > prod.variants[i].price) {
            prod.variants[i].compare_at_price = prod.variants[i].compare_at_price
          } else {
            prod.variants[i].compare_at_price = ""
          }
          prod.variants[i].price    = baDisplayCents(numericPrice);
          prod.variants[i].qtyPrice = baDisplayCents(qtyPrice);

       
        }

        fixedDiscountSet = true
        if (prod.variants.length == 1) {
          prod.variantsStyle = "display: none;";
          prod.firstVariantId       = prod.variants[0].id;
          prod.firstVariantQtyPrice = prod.variants[0].qtyPrice;
        
        }else {
          var variantsHtml = "";
          prod.variants.map(function(variant){
            if (typeof variant.inventory_management == "string" && variant.inventory_management == "shopify") {
              if (typeof variant.inventory_policy == "string" && variant.inventory_policy == "deny" && typeof variant.inventory_quantity == "number" && variant.inventory_quantity <= 0) {
                return
              }
            }

            if (!prod.firstVariantId)  {
              prod.firstVariantId       = variant.id;
              prod.firstVariantQtyPrice = variant.qtyPrice
            
            }
            var baImg = "";
            if (variant.image_src && typeof variant.image_src == "string" && variant.image_src != '')
            {
               baImg = variant.image_src
            }
            else {
            if (variant.image_id != null && typeof variant.image_id == "number") {
              var varImgs = prod.images.filter(function(pi) {return pi.id == variant.image_id});
              if (varImgs.length){baImg = varImgs[0].src}
            } else {
              if (typeof prod.image == "object" && prod.image && typeof prod.image.src == "string") {
                baImg = prod.image.src
              }
            }}

            var n = baImg.lastIndexOf(".");
            if (n >= 0) {
              var s = baImg.substring(0, n) + "_medium." + baImg.substring(n + 1);
              baImg = s
            }
            variantsHtml += "<option value='" + variant.id + "' data-img='" + baImg + "' data-price='" + variant.og_price + "' data-compare-at-price='" + variant.og_compare_at_price + "' data-dis-price='" + (variant.discountedPrice || '')  + "'>";
            variantsHtml += variant.title + "</option>"
          });

          var dataHandle = (window.booster.currentHandle == prod.handle) ? prod.handle : "_";
          prod.variantsSelect = "<select class='ba-variants' data-product-handle='" + dataHandle + "'>";
          prod.variantsSelect += variantsHtml + "</select>"
        }

        if (typeof prod.image == "object" && prod.image && typeof prod.image.src == "string") {
          var n = prod.image.src.lastIndexOf(".");
          if (n >= 0){
            var s = prod.image.src.substring(0, n) + "_medium." + prod.image.src.substring(n + 1);
            prod.image.src = s
          }
        }
        enhancedProducts.push(prod)
      }

  
    //Build an array with request to products
	  ba_data.items.map(function(p){
      arr.push($.getJSON("/products/" + p.handle + ".json",function(data){ enhanceProduct(data,p) }).fail(function(jqXHR, textStatus, errorThrown){
          postNotFoundError(p.handle)
        })
      )
	  });
	

  
		if (arr.length == 0) { return }
  	$.when.apply($, arr).done(function() {
	
      products = enhancedProducts;
      if (products.length == 0)  return false;
      var noVariants = true;
      for (var i = 0; i < products.length; i++) {
        if (products[i].variants.length > 1) {
          noVariants = false
        }
      }
      if (noVariants){
        for (var i = 0; i < products.length; i++) {
          products[i].variantsStyle = "height: 0px;"
        }
      }
    switch (products.length) {
      case 2:
        var cssLength = 'two'
        break;
      case 3:
        var cssLength = 'three'
        break;
      case 4:
        var cssLength = 'four'
        break;
      default:
        var cssLength = 'over-four'
    }

    var source = $("#ba-bundle").html();
    var context = {
      offer_id: ba_data.offerId,
      save_text: ba_data.save_text,
      discount_applies: ba_data.discount_applies,
      ba_bundle: ba_data,
      bundle_note: ba_data.bundle_note,
      products: products,
      css_length: cssLength,
      ba_plus_url: baPlusImageUrl,
      ba_eqs_url: "//cdn.shopify.com/s/files/1/0194/1736/6592/t/1/assets/ba-equals_38x.png?3069916476021763728"
    };
    var template = baHandlebars.compile(source);
    var html = template(context);
    $('div.ba-bundle-wrapper').append(html.replace(/undefined/g, ' '));
    var bundle = $('div.ba-bundle-wrapper .ba-product-bundle').last();

    
    var maxHeight = 0;
    $(bundle).find("div.bundle-name").each(function(i,bn){
       if ($(bn).height() > maxHeight) { maxHeight = $(bn).height(); }
    });
    $(bundle).find("div.bundle-name").height(maxHeight);
    

    
    var matchWidth = true;
    try {
      matchWidth = eval('window.matchMedia("(min-width: 650px)").matches');
    }
    catch(ex){
      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      matchWidth = width >= 650;
    }
    if (matchWidth && $(bundle).find('.ba-eqs:visible').length > 0) {
      var imageContainerHeight = $(bundle).find("div.ba-image-container").height();
      var bundleTotal = $(bundle).find("div.bundle-total");
      var bundleMargin = ((imageContainerHeight - bundleTotal.height()) / 2).toFixed(1);
      bundleTotal.attr('style', "margin-top:" + bundleMargin + "px;margin-bottom:" + bundleMargin + "px;");
    }
    
    var setCurrentVariant = function(newVariantId)  {
      if (!newVariantId) return;
      window.booster.currentVariantId = newVariantId;
      var optionSelector = "select.ba-variants[data-product-handle='" + window.booster.currentHandle  + "']"
      //Try to assign new value only if option present
      if ($(optionSelector +" option[value='" + newVariantId + "']").length > 0)  { $(optionSelector).val(newVariantId).trigger('change') }
    }
    setCurrentVariant(window.booster.currentVariantId);
    actOnVariantChange(setCurrentVariant);
    productPageTestOfferSeen();
    registerEvent('offer_view',{app_type: 'bundle',offer_id: ba_data.offerId})
    reloadCurrency();
  })

	
}

  function getResources(url,resource_name,max_quantity,collection,page,callback)
  {
    //stop extraction if we reached max_quantity
    if (collection.length >= max_quantity) {
      //adjust collection if too many objects extracted
      collection.splice(0, (collection.length - max_quantity));
      callback();
      return;
    }

    $.getJSON(url + ".json?page=" + page, function(data) {
      //if response include some resources
      if (data[resource_name] && data[resource_name].length > 0)
      {
        collection.push.apply(collection,data[resource_name])
        //get more items from the next page
        getResources(url,resource_name, max_quantity, collection, page + 1,callback);
      }
      else //no more resources present
      {
        collection.splice(0, (collection.length - max_quantity));
        callback();
      }
    })
  }

  function addCollectionUpsells(upsell_collection_arr,data,callback) {
    var products        = [];
    var upsell_items    = [];
    var collection =  upsell_collection_arr.collection[0]
    //Todo: loop over collection to get products from different collections?

    getResources("collections/" + collection.handle + "/products", 'products', 3, products, 1, function () {
      products.forEach(function (product) {
        //generate upsell items
        upsell_items.push({product: product,
                           handle: product.handle,
                           id: product.id,
                           discount_applies: upsell_collection_arr.discount_applies,
                           discount_method: upsell_collection_arr.discount_method,
                           offer_id: upsell_collection_arr.offer_id,
                           qty_left: upsell_collection_arr.qty_left,
                           upsell_note: upsell_collection_arr.upsell_note,
                           value: upsell_collection_arr.value})})
      //initialize upsell_array if necessary
      if (!data.discounts.upsell_arr) data.discounts.upsell_arr = [];
      //collect existing upsell product ids.
      var existing_product_ids = data.discounts.upsell_arr.map(function (item) { return item.id   });
      //add upsell items if they not present in the upsell_array yet
      upsell_items.forEach(function (item) {
        var product_position = existing_product_ids.indexOf(item.id)
         //Add or replace item to avoid additional requests to products.
        if (product_position > -1) {
          data.discounts.upsell_arr[product_position] = item;
        } else {
          data.discounts.upsell_arr.push(item);
        }

      })
      callback();
    })
  }

  function upsellDisplayPrice(discount_method,price,compare_at_price) {
    return (discount_method=='no_discount' && compare_at_price && compare_at_price != "") ?  baDisplayCents(compare_at_price) :  price;
  }

  function cssLengthWord(value) {
      switch (value) {
      case 1:
         return 'one'
        break;
      case 2:
        return 'two'
        break;
      case 3:
        return 'three'
        break;
      case 4:
       return 'four'
        break;
      default:
        return 'two'
    }
  }

  function generateUpsellProduct(data,offerId,upsellNote,discount_applies,discount_method,discount_value)
  {
    var prod = data.product;
    prod.offer_id = offerId;
    prod.upsell_note = upsellNote;
    prod.discount_applies = discount_applies;
    prod.variantsStyle = "";
    prod.variantsSelect = "";
  
    //Remove out of stock variants
    prod.variants = prod.variants.filter(function(v){ return window.booster.productsInStock[prod.id].variants_stock[v.id].available =='true' })
  

    for (var i = 0; i < prod.variants.length; i++) {
      if (typeof prod.variants[i].price == "string") {
        prod.variants[i].price = parseFloat(prod.variants[i].price) * 100
      }
      if (typeof prod.variants[i].compare_at_price == "string") {
        prod.variants[i].compare_at_price = parseFloat(prod.variants[i].compare_at_price) * 100
      }
      prod.variants[i].og_compare_at_price = prod.variants[i].compare_at_price;
      prod.variants[i].og_price = prod.variants[i].price;
      if (prod.variants[i].compare_at_price && prod.variants[i].compare_at_price > prod.variants[i].price) {
        prod.variants[i].compare_at_price = prod.variants[i].compare_at_price
      } else {
        prod.variants[i].compare_at_price = ""
      }
      prod.variants[i].price = baDiscountedPrice(prod.variants[i].price, discount_applies, discount_method, discount_value);
      

    }

    //Try to create product image property if it's missing.
    if (typeof prod.image != "object" && typeof prod.images == "object")  {prod.image = prod.images[0];}

    if (prod.variants.length == 1) {
      prod.variantsStyle = "display: none;";
    } else {
      var variantsHtml = "";
      prod.variants.map(function (variant) {
        if (typeof variant.inventory_management == "string" && variant.inventory_management == "shopify") {
          if (typeof variant.inventory_policy == "string" && variant.inventory_policy == "deny" && typeof variant.inventory_quantity == "number" && variant.inventory_quantity <= 0) {
            return
          }
        }
        var baImg = "";
        var image_id;
        //When product received from collection it will include featured_image otherwise image_id
        if (variant.image_id != null && typeof variant.image_id == "number")
        {
          image_id = variant.image_id;
        }
        if (variant.featured_image && typeof variant.featured_image.id == "number")
        {
          image_id = variant.featured_image.id;
        }

        if (image_id) {
          var varImgs = prod.images.filter(function (pi) {
            return pi.id == image_id
          });
          if (varImgs.length) {
            baImg = varImgs[0].src
          }
        } else {
          if (typeof prod.image == "object" && prod.image && typeof prod.image.src == "string") {
            baImg = prod.image.src
          }
        }

        var n = baImg.lastIndexOf(".");
        if (n >= 0) {
          var s = baImg.substring(0, n) + "_medium." + baImg.substring(n + 1);
          baImg = s
        }
        variantsHtml += "<option value='" + variant.id + "' data-img='" + baImg + "' data-price='" + variant.og_price + "' data-compare-at-price='" + variant.og_compare_at_price + "'>";
        variantsHtml += variant.title + "</option>"
      });
      prod.variantsSelect = "<select class='ba-variants'>";
      prod.variantsSelect += variantsHtml + "</select>"
    }

    if (typeof prod.image == "object" && prod.image && typeof prod.image.src == "string") {
      var n = prod.image.src.lastIndexOf(".");
      if (n >= 0) {
        var s = prod.image.src.substring(0, n) + "_medium." + prod.image.src.substring(n + 1);
        prod.image.src = s
      }
    }
    prod.link =   "/products/" + prod.handle ;
    prod.linkClass =  '' ;
    return prod;
  }

  var currentFunnel       = null;
  var mainFunnel          = null;
  var firstFunnel         = true;
  var funnelRefusedTimes  = 0;
  var funnelRefusedLimit  = 1;
  var funnelProductAdded  = false;
  var upsellItemAdded     = false;
  var allFunnelProducts   = null;

  function showBaUpsell(ba_data){
    if (window.selector_mode) {return;}
    var upsell_items    = (ba_data.discounts["upsell_items"] || {})
    var replaceTriggers = upsell_items["replace_trigger"]    || false
    var replaceItems    = upsell_items["items"]              || []
    var replaceVariants = replaceItems.map(function(i){ return i["variant_id"] }) || []

    var arr = [];
    var products = [];
    var upsellItem = ba_data.discounts.upsell_arr[0];
    var offerId = upsellItem.offer_id;
    var upsellNote = upsellItem.upsell_note;
    var discount_applies = upsellItem.discount_applies;
    var discount_method = upsellItem.discount_method;
    var discount_value = upsellItem.value;
    if (ba_data.discounts.funnel && ba_data.discounts.funnel[1]) {
       currentFunnel = ba_data.discounts.funnel[1];
       mainFunnel    = ba_data.discounts.funnel;
    }


    //Limit amount of products according to shop settings
    ba_data.discounts.upsell_arr.splice(0,ba_data.discounts.upsell_arr.length - 10 )
    //populate arr with async actions
    ba_data.discounts.upsell_arr.map(function(p){
      if (p.product){
        arr.push(new Promise(function(resolve, reject) {
                   products.push(generateUpsellProduct({product: p.product},offerId,upsellNote,discount_applies,discount_method,discount_value))
                   resolve(true);
                }));
      }
      else {
        arr.push($.getJSON("/products/" + p.handle + ".json", function(data){
                    products.push(generateUpsellProduct(data,offerId,upsellNote,discount_applies,discount_method,discount_value ));
                }).fail(function(jqXHR, textStatus, errorThrown){
                   postNotFoundError(p.handle);
                }))
      }
	});

	if (arr.length == 0) {
    return
	}
	$.when.apply($, arr).done(function() {
      if (products.length == 0) {
        return
      }
      var noVariants = true;
      for (var i = 0; i < products.length; i++) {
        var offerId = products[i].offer_id;
        var upsellNote = products[i].upsell_note;
        var discount_applies = products[i].discount_applies;
        if (products[i].variants.length > 1) {
          noVariants = false
        }
        products[i].quantity = 1;
        var curProd = ba_data.discounts.upsell_arr.filter(function(p) {
          return p.id == products[i].id
        });
        if (curProd.length == 1 && curProd[0].qty > 1) {
          products[i].quantity = curProd[0].qty
        }
        if (curProd.length == 1 && curProd[0].qty_left) {
          products[i].qty_left = curProd[0].qty_left
        }
      }
      if (noVariants){
        for (var i = 0; i < products.length; i++) {
          products[i].variantsStyle = "height: 0px;"
        }
      }

    var cssLength = cssLengthWord(products.length)

    var source = $("#ba-upsell").html();
    var multiple_products = products.length > 1;
    var context = {
      multiple_products: multiple_products.toString(),
      discount_applies: discount_applies.toString(),
      upsell_note: upsellNote,
      products: products,
      css_length: cssLength,
      ba_plus_url: baPlusImageUrl,
      offer_id: offerId,
      discount_method: discount_method,
      discount_value:  discount_value,
      replace_trigger: replaceTriggers,
      replaceVariants: (replaceVariants || []).join(',')

    };
    var template = baHandlebars.compile(source);
    var html = template(context);
    $('body').append(html.replace(/undefined/g, ' '));
    
    
    $('#dpModal-container').addClass('ba_default_animation').dpModal().addClass('ba_show_animation')
    registerBuyxTestOfferSeen();
    registerEvent('offer_view',{app_type: 'buyx',offer_id: offerId});
    reloadCurrency();
   
    });
  }

  function registerBuyxTestOfferSeen(){
    if ((localStorage.getItem('bd_first_test_offer_return_url') || '').length == 0){return};
    if($('div#dpModal-container:visible').length > 0){
      var result = "success";
    } else {
      var result = "error";
    }
    checkAndShowPreviewJs('buyx', result);
    $.ajax({cache: false,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            type: "POST",
            url: settings.app_root_url,
            data: JSON.stringify({action_type: 'first_test_offer_seen', app: 'buyx', result: result}),
            success: function(res) {
            }})
  }

  function productPageTestOfferSeen(){
    if (document.location.search.indexOf("test_product_offer=1") > -1){
      if (document.location.search.indexOf("bundle_test_product_offer=1") > -1){
        var appType = 'bundle';
        var appVisible = $('div.ba-bundle-wrapper:visible').length > 0
        if (appVisible == true){window.scrollTo(0, $('div.ba-bundle-wrapper:visible').offset().top - 100)}
      } else if (document.location.search.indexOf("dp_test_product_offer=1") > -1){
        var appType = 'dp';
        var appVisible = $('div.ba-vol-wrapper:visible').length > 0
        if (appVisible == true){window.scrollTo(0, $('div.ba-vol-wrapper:visible').offset().top - 100)}
      }

      if (appType){
        if (appVisible == true){
          var result = "success";
        } else {
          var result = "error";
        }
        checkAndShowPreviewJs(appType, result);
        $.ajax({cache: false,
              contentType: "application/json; charset=utf-8",
              dataType: "json",
              type: "POST",
              url: settings.app_root_url,
              data: JSON.stringify({action_type: 'first_test_offer_seen', app: appType, result: result}),
              success: function(res) {
              }})
      }
    }
  }

  function showVolDiscounts(data){
    var source = $("#ba-discount-tiers").html();
    var context = {
      product_message: data.offer_product_message || "Buy at discounted prices",
      vol_rows: data.vol_rows
    };
    var template = baHandlebars.compile(source);
    var html = template(context);
    $('div.ba-vol-wrapper').html(html);
    productPageTestOfferSeen();
    
    registerEvent('offer_view',{app_type: 'dp',offer_id: data.offerId})
    //Trigger 'offer_add_cart' event registration on 'Add to cart' click
    $(document).on('click',baAddToCartSelector,function(){
      registerEvent('offer_add_cart',{app_type: 'dp',offer_id: data.offerId})
    })
    
  }

  function baDelegate(data) {
    if(data.vol_rows && data.vol_rows.length > 0 && (data.type == 'vd' || data.type == 'bundle')){
      
        
          var vdElement = $("form[action*='/cart/add']").first();
        

        if($('.ba-vol-wrapper').length == 0){
          
            vdElement.after("<div class='ba-vol-wrapper'></div>");
          
        }

        showVolDiscounts(data)
      
    }

    if(data.ba_bundles){
      window.booster.currentVariantId = getUrlParam('variant');
      window.booster.currentHandle    = lastUrlSegment();
      if($('.ba-bundle-wrapper').length == 0){
          var referenceElement,bundle_placed;
          var bundle_wrapper= "<div class='ba-bundle-wrapper'></div>";

          

          if (!bundle_placed) {
              referenceElement = $("form[action*='/cart/add']").first();
              referenceElement.after(bundle_wrapper);
          }
      }

      var isPreview  = (document.location.search.indexOf("preview_offer=1") > -1);
      var checkStock = false;
      $(data.ba_bundles).each(function(i,ba)  {
        if (checkStock && !isPreview)  {
          var productHandles = ba.items.map(function(p){ return p.handle });
          allBundleItemsInStock(productHandles,function(allInStock)  {
            //Show only if all products are in stock
            if (allInStock){ showBoosterBundle(ba) }
          })
        } else {
          //old version
          showBoosterBundle(ba);
        }
      });
    }

    //Will return an instance or null if item is not an object.
    var isObject             = function(obj) { return (typeof obj === "object") ? obj : null;}
    var discounts_present    = isObject(data.discounts);

    if (discounts_present) {
      var upsellCollectionPresent = (isObject(data.discounts.upsell_collection_arr) && (data.discounts.upsell_collection_arr.collection || []).length > 0);
      var upsellProductsPresent   = function(){return ((isObject(data.discounts.upsell_arr) || []).length > 0)} //function because 'upsell_arr' updated in out_of_stock_feature_enabled = false version
      //Check and run showBaUpsell
      var checkBaUpsell = function () {
        
          // Stop if no upsells at all
          if (!upsellCollectionPresent && !upsellProductsPresent()) { return; }
          var upsellArr = data.discounts.upsell_arr;
          //Just get all product handles
          var upsellProductHandles = upsellArr.map(function(p){ return p.handle })
        
          var collectionHandles  = (upsellCollectionPresent) ? data.discounts.upsell_collection_arr.collection.map(function(i){return i.handle }) : []
          shuffleArray(collectionHandles);
        

          //Get collection products and stock state
          getVariantsInStock(upsellProductHandles,collectionHandles,false,function(productsStock)  {
            var collectionProductIds = []
            var upsellObj            = data.discounts.upsell_collection_arr;
            var existingProductIds   = upsellArr.map(function (item) { return item.id.toString() });

            for (var productId in productsStock) {
              if (existingProductIds.indexOf(productId) == -1)  collectionProductIds.push(Number(productId))
            }
            
             //randomize displayed products
              shuffleArray(collectionProductIds);
            

            var maxProducts = 3;
            if (maxProducts < collectionProductIds.length) { collectionProductIds.length = maxProducts }
            //Add upsell products from collections
            collectionProductIds.forEach(function(productId)  {
              upsellArr.push({id: productId,
                               discount_applies: upsellObj.discount_applies,
                               discount_method:  upsellObj.discount_method,
                               offer_id:         upsellObj.offer_id,
                               qty_left:         upsellObj.qty_left,
                               upsell_note:      upsellObj.upsell_note,
                               value:            upsellObj.value })
            })

            //Select in stock products
            data.discounts.upsell_arr = upsellArr.filter(function(pr) {
              //Add missing settings and unescape if necessary(per product)
              if (!productsStock[pr.id]) return false
              pr.product          = productsStock[pr.id]
              pr.product.variants = []
              pr.product.title    = unescapeHtml(pr.product.title)
              pr.product.handle   = unescapeHtml(pr.product.handle)
              for (var key in pr.product.variants_stock)  {
                //Add missing settings per variant
                var variant              = pr.product.variants_stock[key];
                variant.price            = parseInt(variant.price)
                variant.title            = unescapeHtml(variant.title)
                variant.image_id         = variant.image_id != '' ? Number(variant.image_id) : variant.image_id;
                variant.compare_at_price = parseInt(variant.compare_at_price)
                pr.product.variants.push(variant)
              }
              return pr.product.available == "true"
            })

            //Show upsell popup if still products available
            if (data.discounts.upsell_arr.length > 0)  showBaUpsell(data);
          })
        
      }

      //check if need to add upsells items from collections(ignored by stock version)
      if (upsellCollectionPresent && false) {
        addCollectionUpsells(data.discounts.upsell_collection_arr, data, function () {
          checkBaUpsell()
        })
      }
      else {
        checkBaUpsell();
      }

      if ((isObject(data.notifications) || []).length > 0 && (data.discounts.upsell_arr || []).length == 0) {
        showBoosterNotification(data.notifications,data)
      }

      if (isObject(data.discounts.cart) && isObject(data.discounts.cart.items)) {
        showCartDiscounts(data.discounts)
      }
    }

    reloadCurrency();
  }

  function showCartDiscounts(discounts) {
    window.booster.discounts = discounts;

    for (var i = 0; i < discounts.cart.items.length; i++) {
      var item = discounts.cart.items[i];

      if (item.discounted_price < item.original_price) {
        $(".booster-cart-item-price[data-key='" + item.key + "']").html("<span class='original_price '>" + item.original_price_format + "</span>" + "<span class='discounted_price '>" + item.discounted_price_format + "</span>");
        $(".booster-cart-item-line-price[data-key='" + item.key + "']").html("<span class='original_price '>" + item.original_line_price_format + "</span>" + "<span class='discounted_price '>" + item.discounted_line_price_format + "</span>")
      }

      $(".booster-cart-item-upsell-notes[data-key='" + item.key + "']").html(item.upsell_note);
      $(".booster-cart-item-success-notes[data-key='" + item.key + "']").html(item.success_note);
    };

    //Avoid any actions if no discounts present in any form.
    if (typeof discounts.discounted_price_html != "string") {
        return
    }

    
      $('.additional_checkout_buttons,.additional-checkout-button,.additional-checkout-buttons').hide();
      addGlobalStyle('.additional_checkout_buttons, .additional-checkout-button, .additional-checkout-buttons  {display:none !important;}')
    

    //Adjust cart totals only if positive discount present
    if (discounts.positive_discount) { displayCartTotals(discounts)}

    //WIP for zero discounts
    if (discounts.zero_discount_only || window.booster.cart.total_price == 0){
      $('form[action*="/cart"]').append("<input type='hidden' value='1' name='attributes[ba_identifier]'>");
      try{ window.booster.cart.attributes["ba_identifier"] = 1 } catch (ex){}
      return
    }

    var checkout_selectors = ["input[name='checkout']", "button[name='checkout']", "[href$='checkout']", "input[name='goto_pp']", "button[name='goto_pp']", "input[name='goto_gc']", "button[name='goto_gc']", ".additional-checkout-button", ".google-wallet-button-holder", ".amazon-payments-pay-button"];
    checkout_selectors.forEach(function(selector) {
        var els = document.querySelectorAll(selector);
        if (typeof els == "object" && els) {
            for (var i = 0; i < els.length; i++) {
                var el = els[i];
                if (typeof el.addEventListener != "function") {
                    return
                }
                el.addEventListener("click", function(ev) {
                  ev.preventDefault();
                  try {
                    

                    DiscountedPricingCheckout(ev);
                  }
                  catch(err) {
                    window.location = '/checkout';
                  }
                }, false);
            }
        }
    })
  }

  function displayCartTotals(discounts)
  {
      if ($(".wh-original-cart-total span.wh-original-price").length > 0) {
          $(".wh-original-cart-total span.wh-original-price").css("text-decoration", "line-through");
      } else {
          $(".wh-original-cart-total").css("text-decoration", "line-through");
      }

      $(".wh-cart-total").html("<span class=''>" + discounts.discounted_price_html + "</span>");

      if (discounts.summary_item_html) {
          var boosterSummaryItemHtml = discounts.summary_item_html;
      } else {
          var boosterSummaryItemHtml = "";
      }
      //some cart_subtotal hiden
      $('.subtotal .cart_savings.sale').hide();


      
      $(".wh-cart-total").prepend("<span class='booster-messages'><div id='booster-summary-item'>" + boosterSummaryItemHtml + "</div><div id='booster-discount-item'></div><div class='booster-discounts-wrapper'><input type='text' id='booster-discount-code' placeholder='Discount Code'><button id='apply-booster-discount' class='btn btn--secondary'>Apply</button></div></span>");
      if (window.booster.discount_code) {
          $('input[id=booster-discount-code]:visible').val(window.booster.discount_code);
          $('div[id=booster-discount-item]').html(discounts.discount_item_html);
      }
      
      $(".wh-cart-total span").css("text-decoration", "none");

      

      reloadCurrency()
  }

  function showBoosterNotification(notifications,data){
     //no notification when we in selector mode.
     if (window.selector_mode) return;
    
    if ((getCookie('booster_notifications_closed') != 1) && notifications != ""){

        var notification_placed = false;
        var lines = [];
        notifications.forEach(function(l){ lines.push("<span>" + l + "</span>") });
        notifications = lines;
        var barHtml = "<div id='booster-notification-bar'><div id='booster-close-notification'>X</div>" + notifications.join(" ") + "</div>";

        

        

        

        if (!notification_placed){
            
            var barElements = ["main", "div.content", "section.main-content", "div#content"];
            barElements.forEach(function(el){
                if ($('#booster-notification-bar').length == 0){
                    if (el == 'main'){
                        $(el).prepend(barHtml);
                    } else {
                        $(el).before(barHtml);
                    }
                }
            });
            
        }

        if ($('#booster-notification-bar').length > 0){
            
              $('#booster-notification-bar').slideDown('slow');
            
        }

      
        if (data.offerId)  {
          registerEvent('offer_view',{app_type: 'dp',offer_id: data.offerId})
          //Trigger 'offer_add_cart' event registration on 'Add to Cart' click
          $(document).on('click',baAddToCartSelector,function(){
            registerEvent('offer_add_cart',{app_type: 'dp',offer_id: data.offerId})
          })
        }
      
      }

  }

  function addBoosterBundle(e){
    e.preventDefault();
    var boosterBundleItems = [];

    $(e.target).parents(".ba-product-bundle").find(".ba-product-wrapper").each(function() {
      var i = {id: $(this).data("variant-id"),quantity: $(this).data("quantity")};
      boosterBundleItems.push(i);
    });

    addBoosterItems(boosterBundleItems, function(){
      setTimeout(function() {window.location.href = "/cart"}, 200)
    });

  }


  function addBoosterUpsells(target){
   var btn = $(target);
   var boosterUpsellItems = [];

   var container = btn.parents(".product-container");
   var offer_id  = btn.data("offer-id")
   
   var i         = {id: container.data("variant-id"),quantity: container.data("quantity")};
   boosterUpsellItems.push(i);

 
   addBoosterItems(boosterUpsellItems, function(){
     setTimeout(function() {window.location.href = "/cart"}, 200)
   });
 
 }




 function addBoosterItems(variants, callback) {
	if (variants.length) {
      var i = variants.shift();
	  $.ajax({
        url: "/cart/add.js",
        type: "POST",
        dataType: "json",
        data: i,
        success: function(data) {
          addBoosterItems(variants, callback)
        },
        error: function(data) {
          if (typeof data == "object" && typeof data.responseJSON == "object" && typeof data.responseJSON.description == "string") {
            alert(data.responseJSON.description)
          }
          if (typeof res == "string") {
            alert(data)
          }
        }
      })
	} else {
      if (typeof callback == "function") {
        return callback()
      }
      setTimeout(function() {
        window.location.reload()
      }, 100)
	}
}

  function DiscountedPricingCheckout(e){
    
    if ($("input[type='checkbox']#agree").length > 0 && $("input[type='checkbox']#agree:checked").length != $("input[type='checkbox']#agree").length) {
      return
    }
    

    $(e.target).prop("disabled", 'disabled');

    for (var i = 0; i < window.booster.cart.items.length; i++) {
      var item = window.booster.cart.items[i];
      var el = document.querySelectorAll("[id='updates_" + item.key + "']");
      if (el.length != 1) {
        el = document.querySelectorAll("[id='updates_" + item.variant_id + "']")
      }
      if (el.length == 1) {
        window.booster.cart.items[i].quantity = el[0].value
      }
    }

    window.booster.action_type = 'checkout';

    var invoiceUrlParams = [];

    var noteAttributes = [];
    $("[name^='attributes']").each(function() {
      var attribute = $(this);
      var name = $(this).attr("name");
      name = name.replace(/^attributes\[/i, "").replace(/\]$/i, "");
      var v = {
        name: name,
        value: attribute.val()
      };
      if (v.value == "") {
        return
      }
      switch (attribute[0].tagName.toLowerCase()) {
        case "input":
          if (attribute.attr("type") == "checkbox") {
            if (attribute.is(":checked")) {
              noteAttributes.push(v)
            }
          } else {
            noteAttributes.push(v)
          }
          break;
        default:
          noteAttributes.push(v)
      }
    });

    var orderNote = "";
    if ($("[name='note']").length) {
      orderNote = $("[name='note']")[0].value
    }
    window.booster.cart.note_attributes = noteAttributes;
    window.booster.cart.note = orderNote;

    if (orderNote.length){
      invoiceUrlParams.push("note=" + encodeURIComponent(orderNote))
    }

    if (noteAttributes.length){
      noteAttributes.map(function(a) {
        invoiceUrlParams.push("attributes" + encodeURIComponent("[" + a.name + "]") + "=" + encodeURIComponent(a.value))
      })
    }

    if(window.booster.discount_method == 'code'){
      $.ajax({
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        type: "POST",
        url: settings.app_root_url,
        data: JSON.stringify(window.booster),
        success: function(res) {
          res.invoice_url = '/checkout';
          if (res.discount_code) {
            setCookie('ba-pr-id', res.pr_id, 14);
            invoiceUrlParams.push("discount=" + res.discount_code);
          }
          if (invoiceUrlParams.length) {
            res.invoice_url += "?" + invoiceUrlParams.join("&")
          }
          window.location.href = res.invoice_url
        },
        error: function(){
          window.location.href = "/checkout"
        }
      })


    } else {

      if (typeof window.gaclientId) {
        invoiceUrlParams.push("clientId=" + window.gaclientId);
        invoiceUrlParams.push("_ga=" + window.gaclientId)
      }

      $.ajax({
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        type: "POST",
        url: settings.app_root_url,
        data: JSON.stringify(window.booster),
        success: function(res) {
          if(res.invoice_url){
            if (invoiceUrlParams.length) {
              res.invoice_url += "?" + invoiceUrlParams.join("&")
            }
            setTimeout(function(){
              window.location.href = res.invoice_url
            }, 500);
          } else {
            window.location.href = "/checkout"
          }
        },
        error: function(){
          window.location.href = "/checkout"
        }
      })

    }


  }

  function openReplacement(method, url, async, user, password) {
      return open.apply(this, arguments);
  }

  function sendReplacement(data) {
      //console.warn('Sending HTTP request data : ', data);
      if(this.onreadystatechange) {
          this._onreadystatechange = this.onreadystatechange;
      }
      this.onreadystatechange = onReadyStateChangeReplacement;
      return send.apply(this, arguments);
  }

  function onReadyStateChangeReplacement() {
      //console.warn('HTTP request ready state changed : ' + this.readyState);
      //if(this._onreadystatechange) {
      //    return this._onreadystatechange.apply(this, arguments);
      //}

      if(this.readyState===4){
        //console.log("Success! " + this._url);
        if (this._url == '/cart/change.js'){
          window.location.reload();
        }
      }
  }

  


  function notifyCalculationsInProgress()  {
    
    return true;
  }

  function hideCalculationsInProgressNote()  {
   
    return true;
  }

  if(window.booster.ba_page == 'cart'){
    var skipIds = getCookie('ba-skip-ids');
    if (skipIds){
      window.booster.skip_ids = skipIds;
    }
  }

  //Get offer test token to enable testing
  var previewOfferToken = localStorage.getItem('bd_first_test_offer_token');
  if(previewOfferToken){
  window.booster.ba_test_offer_token = previewOfferToken;
  } else {
  window.booster.ba_test_offer_token = getUrlParam('ba_test_offer_token');
  }

  if(window.booster.ba_page.length > 0){
    notifyCalculationsInProgress();
    $.ajax({
      cache: false,
      type: "POST",
      url: settings.app_root_url,
      data: JSON.stringify(window.booster),
      dataType: 'json',
      contentType: "application/json; charset=utf-8",
      success: function(data) {
        
          baDelegate(data)
        
      }
    });
  }

  setTimeout(function(){
    // Only a real Universal Analytics tracker supports getAll. Shopify's
    // migration stub is callable but logs an error instead of returning a tracker.
    if (typeof window.ga === 'function' && typeof window.ga.getAll === 'function') {
      window.ga(function(tracker) {
        if (tracker && typeof tracker.get === 'function') window.gaclientId = tracker.get('clientId');
      });
    }
  }, 1000);

  function getRefreshDelayValue(){
    var delaySubmit = '';
    if( isMobileBrowser() ){
      delaySubmit = "2";
    }else{
      delaySubmit = "0.5";
    }
    return parseFloat(delaySubmit) * 1000; // convert to milliseconds
  }

  function submitCartForm(){
    setTimeout(function(){ $('form[action*="/cart"]').submit()}, 300);
  }

 

    var debutEditBtnExists = ($('div.cart__edit button.btn.cart__edit--active:visible').length > 0);
    var qtyInputEvent = debutEditBtnExists ? "" :  "input " ;
    $(document).on(qtyInputEvent + 'change', "input.booster-quantity, input[name^='updates['], input[id^='updates_'], input[id^='Updates_']", function(e) {
      var self = this;
      e.preventDefault();
    
      if($.trim($(this).val()) != '') {
         notifyCalculationsInProgress();
        //Delay cart submit to make input more user friendly specially on mobile
        setTimeout(function(){  submitCartForm()  }, getRefreshDelayValue());
      };
    });

  if(window.booster.ba_page == 'cart'){

    $(document).on('click', "td.cart-qty span.icon-plus, td.cart-qty span.icon-minus", function(e) {
      e.preventDefault();
      $(this).parents('form[action*="/cart"]').submit();
    });

    $(document).ajaxSuccess(function(evt,xhr,attrs) {
      if (attrs && attrs.url == '/cart/change.js'){
        window.location.reload();
      }
    });

  
    setTimeout(function(){
      $('.js-qty__adjust').off('click');
    }, 500);
    $(document).on('click', "div.js-qty .js-qty__adjust", function(e) {
      e.preventDefault();
  	  var currentValue = parseInt($(this).parents('div.js-qty').find('input').val());
  	  if($(this).hasClass('js-qty__adjust--plus')){
        var newValue = currentValue + 1
      } else {
        var newValue = currentValue - 1
      }
      $(this).parents('div.js-qty').find('input').val(newValue).change();
    });
  
  }

  $(document).on('change', 'select.ba-variants', function(){
      var option = $(this).find(":selected");
      var price  = baDisplayCents(option.data('price'));
      var cont = option.parents('.ba-product-wrapper');
      var img  = option.data('img');

       
        cont.find('.ba-price span.ba-sale').html(price);
       

      cont.data("variant-id", option.val());
      cont.find('img').attr('src', img);
      reloadCurrency();
      return false;
    });

  $(document).on('change', '#dpModal-container select.ba-variants', function(){
      var option = $(this).find(":selected");
      var upsellCont = option.parents('.ba-product-bundle');
      var cont = option.parents('.product-container');
      var discountMethod = upsellCont.data('discount-method');
      var discountValue  = upsellCont.data('discount-value');
      var discountApplies  = upsellCont.data('discount-applies');
      var compare_at_price = option.data('compare-at-price');
      var price  = baDiscountedPrice(option.data('price'), discountApplies, discountMethod, discountValue);
      var img 	 = option.data('img');

      cont.data("variant-id", option.val());
    
      cont.find('span.ba-sale').html(price);
    
      cont.find('img').attr('src', img);
      reloadCurrency();
      return false;
  });

  $(document).on('click', ".add-booster-bundle", function(e) {
    e.preventDefault();
    addBoosterBundle(e);
    
    //Register add to cart
    var offerId = $(this).parents('div.ba-bundle-wrapper').find('div.bundle-title').data('offerId')
    registerEvent('offer_add_cart',{app_type: 'bundle',offer_id:  offerId})
    
  });

  $(document).on('click', ".add-upsells", function(e) {
    e.preventDefault();
    addBoosterUpsells(e.target);
    var offerId = $(this).data('offerId')
    registerEvent('offer_add_cart',{app_type: 'buyx',offer_id:  offerId})
  });

  

  $(document).on($.dpModal.BEFORE_CLOSE, function(event, modal){
    var link = $('#dpModal-container').find('.no-thanks a');
    var offerId = link.data('offer-id');
    hideUpsell(offerId)
    refreshIfProductAdded();
  });

  function hideUpsell(offerId){
    var currentSkipIds = getCookie('ba-skip-ids');
    if (currentSkipIds && currentSkipIds !='') currentSkipIds += ','
    var allSkipIds = currentSkipIds + offerId;
    
      setCookie('ba-skip-ids', allSkipIds, 14);
    
  }

  function refreshIfProductAdded(){
  
    return true;
  }


 
  $(document).on('click', '.no-thanks a', function(){
    var link = $(this);
    var offerId = link.data('offer-id')
    hideUpsell(offerId)
    $.dpModal.close()
    return false;
  });


  $(document).on('click', "button#apply-booster-discount", function(e) {
    e.preventDefault();
    setCookie('booster_discount_' + window.booster.cart.token, $('input[id=booster-discount-code]:visible').val().trim())
    window.location.reload();
  });

  $(document).on('click', "div#booster-close-notification", function(e) {
    e.preventDefault();
    //var closedNotifications = getCookie('booster_notifications_closed')
    setCookie('booster_notifications_closed', 1, 0.01);
    $('#booster-notification-bar').slideUp('slow');
  });

  $(document).on('click','.booster-variants-container select.ba-variants',function()  {
    //Just an alert in case all variants are out of stock
    if ($(this).children('option').length < 1)  {
      alert('All item variants are out of stock');
    }
  })



})
}(window, document));
